import React, { useRef } from 'react';
import { useAccountUser } from '@ukpostbox/client-data';
import UserPageHeader from '../Components/UserPageHeader';
import UserPageFooter from '../Components/UserPageFooter';
import SendsHistoryControl from '../../ProfilesAdmin/Components/Controls/SendsHistoryControl';
import SendMailHistoryProvider from '../../Providers/SendMailHistoryProvider';

function UserSendsHistory() {
	const { data } = useAccountUser();
	const sendsHistoryRef = useRef<any>(null);

	return (
		<SendMailHistoryProvider userId={data?.id}>
			<div className='container' ref={sendsHistoryRef}>
				<UserPageHeader />

				<div className='row mt-sm mb-xl'>
					<div className='col-xs-12 col-center-lg-10 col-center-xl-8'>
						<div className='card'>
							<SendsHistoryControl containerRef={sendsHistoryRef} forceHeader />
						</div>
					</div>
				</div>

				<UserPageFooter />
			</div>
		</SendMailHistoryProvider>
	);
}

export default UserSendsHistory;
